import "../../css/FullEvent/Checkout.css";
import { memo, useMemo } from "react";
import {
  Event,
  CustomTicketV2,
  PromoCode,
  AccountData,
  TicketV2,
  SavedFormQuestion,
} from "@markit/common.types";
import { FullEventInputForm } from "../FullEvent/FullEventInputForm";
import { checkIsDesktop } from "../../utils/screenResponsivenessUtils";
import { useWindowResize } from "../../hooks/useWindowResize";

type CheckoutProps = {
  event: Event;
  host: AccountData;
  tixId: string;
  ticketData?: TicketV2;
  ticketToRedeem: CustomTicketV2 | undefined;
  promoterId: string;
  promoCode?: PromoCode;
  userReferrer: string;
  selectedCustomTickets: CustomTicketV2[];
  setSelectedCustomTickets: (selectedTickets: CustomTicketV2[]) => void;
  isEventAtCapacity: boolean;
  eventFormQuestions: SavedFormQuestion[];
};

/** Checkout screen to navigate the user to when they press Buy Now on BuyBanner.tsx **/
export const Checkout = memo(function CheckoutFn(props: CheckoutProps) {
  const {
    event,
    host,
    tixId, // redeem
    ticketData,
    ticketToRedeem,
    promoterId, // promoterId
    promoCode, // promoCode
    userReferrer,
    selectedCustomTickets,
    setSelectedCustomTickets,
    isEventAtCapacity,
    eventFormQuestions,
  } = props;

  const windowWidth = useWindowResize();
  const isDesktopSize = useMemo(
    () => checkIsDesktop(windowWidth),
    [windowWidth]
  );

  if (!event) return null;

  return (
    <div
      className="ColumnNormal"
      style={{
        alignItems: "center",
        width: isDesktopSize ? "100%" : undefined,
        padding: `${isDesktopSize ? 60 : 30}px ${
          isDesktopSize ? 0 : 24
        }px 60px`,
      }}
    >
      <FullEventInputForm
        selectedCustomTickets={selectedCustomTickets}
        setSelectedCustomTickets={setSelectedCustomTickets}
        event={event}
        host={host}
        tixId={tixId}
        ticketData={ticketData}
        ticketToRedeem={ticketToRedeem}
        promoCode={promoCode}
        promoterId={promoterId}
        userReferrer={userReferrer}
        isEventAtCapacity={isEventAtCapacity}
        eventFormQuestions={eventFormQuestions}
      />
    </div>
  );
});
